"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var favicon_1 = __importDefault(require("./favicon"));
var faviconNotification_1 = __importDefault(require("./faviconNotification"));
var useFavicon = function (notifications) {
    if (notifications === void 0) { notifications = false; }
    var _a = __read((0, react_1.useState)(null), 2), link = _a[0], setLink = _a[1];
    (0, react_1.useEffect)(function () {
        var head = document.querySelector('head');
        if (!head) {
            head = document.createElement('head');
            document.insertBefore(head, document.body);
        }
        var links = head.querySelectorAll('link[rel*=icon]');
        links.forEach(function (link) { return head === null || head === void 0 ? void 0 : head.removeChild(link); });
        var pngLink = document.createElement('link');
        pngLink.rel = 'icon';
        pngLink.type = 'image/png';
        head.appendChild(pngLink);
        setLink(pngLink);
    }, []);
    (0, react_1.useEffect)(function () {
        if (link) {
            link.href = notifications ? faviconNotification_1.default : favicon_1.default;
        }
    }, [link, notifications]);
};
exports.default = useFavicon;
//# sourceMappingURL=index.js.map